// extracted by mini-css-extract-plugin
export default {"customswiper":"caroussel_customswiper__Gc+ae","swiperslide":"caroussel_swiperslide__ScVzo"};